import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const NAV = [
  { path: '/',           icon: '⬡',  label: 'Dashboard'        },
  { path: '/users',      icon: '◈',  label: 'Users'            },
  { path: '/audience',   icon: '📊', label: 'Audience'         },
  { path: '/geography',  icon: '🌍', label: 'User Geography'   },
  { path: '/analytics',  icon: '◎',  label: 'Analytics'        },
  { path: '/payments',   icon: '◇',  label: 'Payments'         },
  { path: '/economics',  icon: '💰', label: 'Economics'        },
  { path: '/safety',     icon: '⚠',  label: 'Safety'           },
  { path: '/reports',    icon: '🚩', label: 'AI Reports'       },
  { path: '/resets',     icon: '🔐', label: 'Password Resets'  },
  { path: '/threats',    icon: '🛡',  label: 'Threat Intel'     },
  { path: '/errors',     icon: '🚨', label: 'Errors'           },
  { path: '/app-updates', icon: '📲', label: 'App Updates'      },
  { path: '/affiliate',  icon: '🛒', label: 'Affiliate'        },
];

export default function Sidebar({ user, onSignOut }) {
  const location = useLocation();

  return (
    <aside style={{
      position:'fixed',top:0,left:0,bottom:0,width:260,
      background:'#0D1117',
      borderRight:'1px solid rgba(0,135,81,0.12)',
      display:'flex',flexDirection:'column',zIndex:100,
    }}>
      <style>{`
        .nav-link{
          display:flex;align-items:center;gap:12px;padding:12px 20px;
          color:rgba(255,255,255,0.45);text-decoration:none;
          font-size:14px;font-weight:500;border-radius:0;
          transition:all 0.2s;position:relative;letter-spacing:0.3px;
          margin:2px 10px;border-radius:10px;
        }
        .nav-link:hover{color:#fff;background:rgba(0,135,81,0.08);}
        .nav-link.active{color:#008751;background:rgba(0,135,81,0.12);}
        .nav-link.active::before{
          content:'';position:absolute;left:-10px;top:6px;bottom:6px;width:3px;
          background:#008751;border-radius:0 3px 3px 0;
        }
        .nav-icon{
          width:34px;height:34px;display:flex;align-items:center;
          justify-content:center;border-radius:9px;font-size:14px;
          background:rgba(255,255,255,0.04);flex-shrink:0;
          transition:all 0.2s;
        }
        .nav-link:hover .nav-icon{background:rgba(0,135,81,0.1);}
        .nav-link.active .nav-icon{background:rgba(0,135,81,0.18);color:#008751;}
      `}</style>

      {/* Logo */}
      <div style={{padding:'28px 24px 24px',borderBottom:'1px solid rgba(0,135,81,0.1)'}}>
        <div style={{display:'flex',alignItems:'center',gap:14}}>
          <div style={{width:40,height:40,
            background:'linear-gradient(135deg, rgba(0,135,81,0.2), rgba(212,175,55,0.15))',
            borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center',
            fontSize:20,border:'1px solid rgba(0,135,81,0.3)'}}>🎭</div>
          <div>
            <div style={{fontFamily:'Syne',fontWeight:800,fontSize:16,
              background:'linear-gradient(135deg, #008751, #D4AF37)',
              WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent',
              letterSpacing:1.5}}>ORAKU</div>
            <div style={{fontSize:10,color:'rgba(255,255,255,0.3)',letterSpacing:2.5,
              marginTop:2,fontWeight:500}}>ADMIN PANEL</div>
          </div>
        </div>
      </div>

      {/* Nav Section Label */}
      <div style={{padding:'20px 24px 8px',fontSize:10,color:'rgba(255,255,255,0.2)',
        letterSpacing:2,textTransform:'uppercase',fontWeight:600}}>Navigation</div>

      {/* Nav */}
      {/* Scrolls on its own so the Sign Out footer stays on screen
          once the menu is taller than the window. */}
      <nav style={{flex:1,minHeight:0,overflowY:'auto',paddingBottom:8}}>
        {NAV.map(item => (
          <NavLink key={item.path} to={item.path}
            className={({isActive}) => 'nav-link' + (isActive ? ' active' : '')}
            end={item.path === '/'}>
            <span className="nav-icon">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* System Status */}
      <div style={{padding:'12px 20px',margin:'0 10px',
        background:'rgba(0,135,81,0.06)',borderRadius:10,marginBottom:12}}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
          <div style={{width:7,height:7,borderRadius:'50%',background:'#008751',
            boxShadow:'0 0 8px rgba(0,135,81,0.5)'}} />
          <span style={{fontSize:11,color:'rgba(255,255,255,0.4)',fontWeight:500}}>
            System Online
          </span>
        </div>
        <div style={{fontSize:10,color:'rgba(255,255,255,0.2)',fontFamily:'DM Mono'}}>
          Firebase Connected
        </div>
      </div>

      {/* User + Sign out */}
      <div style={{padding:16,borderTop:'1px solid rgba(255,255,255,0.06)'}}>
        <div style={{display:'flex',alignItems:'center',gap:10,marginBottom:12}}>
          <div style={{width:34,height:34,borderRadius:'50%',
            background:'linear-gradient(135deg, rgba(0,135,81,0.2), rgba(212,175,55,0.15))',
            display:'flex',alignItems:'center',justifyContent:'center',
            border:'1px solid rgba(0,135,81,0.3)',
            fontSize:13,fontWeight:700,color:'#008751'}}>
            {user?.email?.[0]?.toUpperCase() || 'A'}
          </div>
          <div style={{overflow:'hidden',flex:1}}>
            <div style={{fontSize:12,fontWeight:600,color:'#fff',
              whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
              {user?.email?.split('@')[0]}
            </div>
            <div style={{fontSize:10,color:'rgba(255,255,255,0.3)'}}>Super Admin</div>
          </div>
        </div>
        <button onClick={onSignOut}
          style={{width:'100%',padding:'9px',background:'rgba(239,68,68,0.08)',
            border:'1px solid rgba(239,68,68,0.15)',borderRadius:10,
            color:'rgba(239,68,68,0.7)',fontSize:12,fontWeight:600,
            transition:'all 0.2s',letterSpacing:0.3}}>
          Sign Out
        </button>
      </div>
    </aside>
  );
}
